import { useMutation } from '@tanstack/react-query';
import { candidatesApi } from '../candidatesApi';
import { MutationKey } from '@shared/config';

export const useExportCandidates = () => {
  return useMutation({
    mutationKey: [MutationKey.EXPORT_VACANCY],
    mutationFn: async ({
      dateFrom,
      dateTo,
    }: {
      dateFrom: string | null;
      dateTo?: string | null;
    }) => {
      const response = candidatesApi.exportCandidates({ dateFrom, dateTo });
      return response;
    },
  });
};
